const OveviewChart = {
    series: [{
        type: 'area',
        name: 'BTC',
        data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47]
    }, {
        type: 'area',
        name: 'ETH',
        data: [28, 41, 52, 42, 13, 18, 29, 18, 36, 51, 55, 35]
    }, {
        type: 'line',
        name: 'LTC',
        data: [45, 52, 38, 24, 33, 65, 45, 75, 54, 18, 28, 10]
    }],
    chartOptions: {
        chart: {
            height: 240,
            type: 'line',
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 2,
            dashArray: [0, 0, 3]
        },
        fill: {
            type: 'solid',
            opacity: [0.15, 0.05, 1],
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        colors: ['#f1b44c', '#3452e1', '#50a5f1'],
    }
};

const attendanceData = [
    {
        empId :0,
        name: 'Steven Franklin',
        email: 'Buy',
        teamId: 0,
        teamName: '',
        designation: '',
        clockIn: '10 : 25',
        clockOut: '18 : 35',
        clockInRemarks: 'Late by 25 mins.',
        clockOutRemarks: '25 Mins Early.',
        clockInColor: 'warning',
        clockOutColor: 'warning',
        remarks : 'In for 8 Hrs 10 Minues',
    },
    {
        userId: '#SK3215',
        name: 'Adam Miller',
        email: 'Buy',
        clockIn: '-- : --',
        clockOut: '-- : --',
        clockInRemarks: 'Not Yet.',
        clockOutRemarks: 'Not Yet.',
        clockInColor: 'secondary',
        clockOutColor: 'secondary',
        remarks : 'No events detected.',
    },

    {
        name: 'Keith Gonzales',
        email: 'Buy',
        clockIn: '-- : --',
        clockOut: '-- : --',
        clockInRemarks: 'N.A',
        clockOutRemarks: 'N.A',
        clockInColor: 'secondary',
        clockOutColor: 'secondary',
        remarks : 'On leave',
    },
    {
        name: 'Keith Gonzales',
        email: 'Buy',
        clockIn: '09 : 45',
        clockOut: '19 : 00',
        clockInRemarks: '15 mins Early.',
        clockOutRemarks: 'On Time.',
        clockInColor: 'success',
        clockOutColor: 'success',
        remarks : 'In for 9 hrs 15 mins',
    },
    {
        name: 'Mitchel Givens',
        email: 'Buy',
        clockIn: '10 : 30',
        clockOut: '18 : 00',
        clockInRemarks: '30 mins Late.',
        clockOutRemarks: '1 hr early.',
        clockInColor: 'warning',
        clockOutColor: 'danger',
        remarks : 'In for 7 hrs 30 mins',
    },
    {
        name: 'Stephen Hadley',
        email: 'Buy',
        clockIn: '11 : 00',
        clockOut: '18 : 30',
        clockInRemarks: '30 mins Late.',
        clockOutRemarks: '30 mins Early.',
        clockInColor: 'warning',
        clockOutColor: 'warning',
        remarks : 'In for 7 hrs 30 mins.',
    },
    {
        name: 'Leord Joseph',
        email: 'Buy',
        clockIn: '09 : 55',
        clockOut: '19 : 05',
        clockInRemarks: '5 mins Early.',
        clockOutRemarks: '5 mins Late.',
        clockInColor: 'success',
        clockOutColor: 'success',
        remarks : 'In for 10 hrs 10 mins.',
    },
    {
        name: 'Steve Harvy',
        email: 'Buy',
        clockIn: '10 : 12',
        clockOut: '18 : 00',
        clockInRemarks: '12 mins Late.',
        clockOutRemarks: '1 hr early.',
        clockInColor: 'success',
        clockOutColor: 'danger',
        remarks : 'In for 8 hrs 48 mins.',
    },
    
    {
        name: 'Adam Smith',
        email: 'Buy',
        clockIn: '10 : 05',
        clockOut: '19 : 00',
        clockInRemarks: '5 mins Late.',
        clockOutRemarks: 'On Time.',
        clockInColor: 'success',
        clockOutColor: 'success',
        remarks : 'In for 8 hrs 55 mins.',
    },
    {
        name: 'Valentina',
        email: 'Buy',
        clockIn: '11 : 05',
        clockOut: '18 : 00',
        clockInRemarks: '1 hr 5 mins Late.',
        clockOutRemarks: '1 hr early.',
        clockInColor: 'danger',
        clockOutColor: 'danger',
        remarks : 'In for 6 hrs 55 mins.',
    },
    {
        name: 'Mitchel Stark',
        email: 'Buy',
        clockIn: '10 : 00',
        clockOut: '19 : 00',
        clockInRemarks: 'On Time.',
        clockOutRemarks: 'On Time.',
        clockInColor: 'success',
        clockOutColor: 'success',
        remarks : 'In for 9 hrs.',
    },
    {
        name: 'Mitchel Givens',
        email: 'Buy',
        clockIn: '10 : 15',
        clockOut: '19 : 15',
        clockInRemarks: '15 mins Late.',
        clockOutRemarks: '15 mins Late.',
        clockInColor: 'success',
        clockOutColor: 'success',
        remarks : 'In for 9 hrs.3',
    },
    {
        name: 'Stephen Hadley',
        email: 'Buy',
        clockIn: '09 : 40',
        clockOut: '17 : 55',
        clockInRemarks: '20 mins Early.',
        clockOutRemarks: '1 hr 5 mins Early.',
        clockInColor: 'warning',
        clockOutColor: 'danger',
        remarks : 'In for 8 hrs 15 mins',
    },
    {
        name: 'Leord Joseph',
        email: 'Buy',
        clockIn: '10 : 30',
        clockOut: '18 : 48',
        clockInRemarks: '30 mins Late.',
        clockOutRemarks: '12 mins Early.',
        clockInColor: 'warning',
        clockOutColor: 'success',
        remarks : 'In for 8 hrs 18 mins.',
    },
    
    
]

const leaveData = [
    {
        name: 'Valentina',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Marriage', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'James Frankiln',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Knee Transplant Surgery', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Michael',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'For Tour', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Tom Woods',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Family Function', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Natalia',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Mothers Treatment', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Charles',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Marriage', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Jordan',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'For Tour to Europe', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Cassandra',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Treatment of Cancer', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
    {
        name: 'Angelina',
        email: '',
        designation: '',
        teamId: 0,
        teamName: '',
        leaveReason: 'Family Function', 
        fromDate: '2022-03-21',
        toDate: '2022-03-27',
        noOfDays: 0,
        status: 0,
        thisMonthLeaveLeft: 0,
        thisYearLeaveLeft: 0,
        remarks: ''
    },
]

export { OveviewChart, attendanceData, leaveData };